import {AfterViewInit, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {of, ReplaySubject} from "rxjs";
import {FileManagerTag} from "../../../../shared/interface/file-manager-tag";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  DictService,
} from "../../../../shared/services/dict.service";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {UserService} from "../../../../shared/services/user.service";
import {delay, takeUntil, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {FileManagerTagService} from "../../../../shared/services/file-manager-tag.service";

export interface TagDialogData {
  tag: FileManagerTag;
  mod: boolean;
}

@Component({
  selector: 'app-tag-add',
  templateUrl: './tag-add.component.html',
  styleUrls: ['./tag-add.component.scss']
})
export class TagAddComponent implements  OnInit, OnDestroy, AfterViewInit  {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() tag?: FileManagerTag;
  @Input() mod = false;

  tagForm: FormGroup;
  nameControl: FormControl;
  activeControl: FormControl;
  errors: any = {};
  userPermissions: ReplaySubject<UserPermissions>;
  processingRequest = false;
  tagsFormValid = false;

  constructor(
    public dialogRef: MatDialogRef<TagAddComponent>,
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private fileManagerTagService: FileManagerTagService,
    private auth: AuthService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: TagDialogData,
  ) {
    this.mod = data.mod ?? false;
    this.tag = data.tag ?? null;
    this.userPermissions = auth.getUserPermissions();
    this.tagForm = fb.group({
      uuid: fb.control(''),
      active: this.activeControl = this.fb.control(true),
      name: this.nameControl = this.fb.control('', [Validators.required]),

    });
  }

  ngOnInit(): void {
    this.tagForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.tagsFormValid = this.tagForm.valid);
  }

  ngAfterViewInit(): void {
    if (this.tag) {
      this.initialize(this.tag);
    } else {
      this.initialized.next(true);
    }
  }

  initialize(tag: FileManagerTag): void {
    of(tag)
      .pipe(
        delay(0),
        tap(() => {
          this.tagForm.reset({
            uuid: tag.uuid,
            name: tag.name,
            active: tag.active,
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  sendForm(): void {
    this.formHelper.removeBackendErrorState(this.tagForm, this.errors);
    this.errors = {};
    if (this.processingRequest) {
      return;
    }
    this.processingRequest = true;
    this.fileManagerTagService.send(this.tagForm.value, this.tag?.uuid)
      .subscribe(() => {
        this.snack.open(this.tag ? 'Pomyślnie zaktualizowano TAG' : 'Pomyślnie dodano TAG', '', {
          duration: 2000,
        });
        this.processingRequest = false;
          this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.tagForm, this.errors);
          this.snack.open(error.error.error.text, '400', {duration: 2000});
        } else {
          this.snack.open('Podczas dodawania postu wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
